import script from "./productListTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./productListTable.vue?vue&type=script&lang=ts&setup=true"

import "./productListTable.vue?vue&type=style&index=0&id=91cdbb24&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91cdbb24"]])

export default __exports__